require('angular').module('wowApp.shop')
    .directive('wowIdVerification', ['ShopperService', 'CurrentUserService', 'AtmService', '$location', require('./id-verification-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/id-verification/index.js
 **/